/**
 * Generated by orval - Do not edit manually.
 * Buildertrend API (all versions)
 * A view showing all available versions of the API. Some routes may be deprecated. Use the latest version available whenever possible.
 * OpenAPI spec version: all
 * If there are merge conflicts to this file,
 * please rebuild the Clients.Api project to resolve.
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import { apixHandler } from "../../apix-handler";
import type { BodyType, ErrorType } from "../../apix-handler";
import type {
  ActivationResponse,
  AdminUsersImpersonationSetupGetV2Params,
  AdminUsersInternalUsersGetV2Params,
  AdminUsersOrgLinkUsersGetV2Params,
  AdminUsersSubsDeleteV2Params,
  AdminUsersSubsGetV2Params,
  AdminUsersUsernameSearchGetV2Params,
  AssignOrgOwnerRequest,
  Auth0MfaEnrollmentTicketResponse,
  AuthStoreForUsernameResponse,
  BadRequestResponse,
  BulkActionRequest,
  BulkActionResponse,
  ChangeEmailRequest,
  ChangeEmailResponse,
  ChangeUsernameContract,
  ChangeUsernameRequest,
  CommunityExternalUserResponse,
  DeactivateGlobalUsersByEmailRequest,
  ExternalCompanyInformationResponse,
  ExternalUserIdentityContract,
  ExternalUserResponse,
  ForbiddenResponse,
  GetUserActivationResponse,
  IdpUserUpdateRequest,
  ImpersonationSetupResponse,
  InternalUsersResponse,
  InternalUsersSetupResponse,
  LockoutInformationResponse,
  LockoutVerificationResponse,
  MassInviteUsersForBuilderInfoResponse,
  MassInviteUsersForBuilderRequest,
  MassInviteUsersOnBuilderResponse,
  OrgLinkUsersResponse,
  ProblemDetails,
  SendUserInvitationContract,
  SendUserInvitationRequest,
  SubsResponse,
  UserActivationRequest,
  UserDeactivationRequest,
  UsernameLookupContract,
  UserOptInRequest,
  UsersAuthStoreForUsernameGetV2Params,
  UsersGetExternalCompanyInformationGetV2Params,
  UsersPhoneVerifyByShareTokenGetV2Params,
  UsersPhoneVerifyByShareTokenPostV2Params,
  UsersSmsVerifyByShareTokenGetV2Params,
  UsersSmsVerifyByShareTokenPostV2Params,
} from ".././models";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * **Authorization**: `user-bearer`


**Authentication**: `auth0` | `LegacyBearer`


**Policy**: `ExternalUser`


**Stability Level**: `stable`
 * @summary Get information about the requested User.
 */
export const usersGetV2 = (
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<ExternalUserResponse>(
    { url: `/apix/v2/Users`, method: "GET", signal },
    options,
  );
};

export const getUsersGetV2QueryKey = () => {
  return [`/apix/v2/Users`] as const;
};

export const getUsersGetV2QueryOptions = <
  TData = Awaited<ReturnType<typeof usersGetV2>>,
  TError = ErrorType<void>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof usersGetV2>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof apixHandler>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUsersGetV2QueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof usersGetV2>>> = ({
    signal,
  }) => usersGetV2(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof usersGetV2>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type UsersGetV2QueryResult = NonNullable<
  Awaited<ReturnType<typeof usersGetV2>>
>;
export type UsersGetV2QueryError = ErrorType<void>;

/**
 * @summary Get information about the requested User.
 */

export function useUsersGetV2<
  TData = Awaited<ReturnType<typeof usersGetV2>>,
  TError = ErrorType<void>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof usersGetV2>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getUsersGetV2QueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * **Authorization**: `user-bearer`


**Authentication**: `LegacyBearer` | `passthrough`


**Policy**: `IdentityProviders`


**Stability Level**: `stable`
 * @summary Get identity information about the requested User.
 */
export const usersIdentityGetV2 = (
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<ExternalUserIdentityContract>(
    { url: `/apix/v2/Users/identity`, method: "GET", signal },
    options,
  );
};

export const getUsersIdentityGetV2QueryKey = () => {
  return [`/apix/v2/Users/identity`] as const;
};

export const getUsersIdentityGetV2QueryOptions = <
  TData = Awaited<ReturnType<typeof usersIdentityGetV2>>,
  TError = ErrorType<void>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof usersIdentityGetV2>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof apixHandler>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUsersIdentityGetV2QueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof usersIdentityGetV2>>
  > = ({ signal }) => usersIdentityGetV2(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof usersIdentityGetV2>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type UsersIdentityGetV2QueryResult = NonNullable<
  Awaited<ReturnType<typeof usersIdentityGetV2>>
>;
export type UsersIdentityGetV2QueryError = ErrorType<void>;

/**
 * @summary Get identity information about the requested User.
 */

export function useUsersIdentityGetV2<
  TData = Awaited<ReturnType<typeof usersIdentityGetV2>>,
  TError = ErrorType<void>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof usersIdentityGetV2>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getUsersIdentityGetV2QueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * **Authorization**: `machine-to-machine-bearer`


**Authentication**: `auth0`


**Policy**: `ExternalService`


**Stability Level**: `stable`
 * @summary Get information about the specified user.
 */
export const usersByUserIdGetV2 = (
  userId: string,
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<ExternalUserResponse>(
    { url: `/apix/v2/Users/${userId}`, method: "GET", signal },
    options,
  );
};

export const getUsersByUserIdGetV2QueryKey = (userId?: string) => {
  return [`/apix/v2/Users/${userId}`] as const;
};

export const getUsersByUserIdGetV2QueryOptions = <
  TData = Awaited<ReturnType<typeof usersByUserIdGetV2>>,
  TError = ErrorType<void>,
>(
  userId: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof usersByUserIdGetV2>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apixHandler>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getUsersByUserIdGetV2QueryKey(userId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof usersByUserIdGetV2>>
  > = ({ signal }) => usersByUserIdGetV2(userId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!userId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof usersByUserIdGetV2>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type UsersByUserIdGetV2QueryResult = NonNullable<
  Awaited<ReturnType<typeof usersByUserIdGetV2>>
>;
export type UsersByUserIdGetV2QueryError = ErrorType<void>;

/**
 * @summary Get information about the specified user.
 */

export function useUsersByUserIdGetV2<
  TData = Awaited<ReturnType<typeof usersByUserIdGetV2>>,
  TError = ErrorType<void>,
>(
  userId: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof usersByUserIdGetV2>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apixHandler>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getUsersByUserIdGetV2QueryOptions(userId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `draft`
 */
export const usersByUserIdPatchV2 = (
  userId: number,
  idpUserUpdateRequest: BodyType<IdpUserUpdateRequest>,
  options?: SecondParameter<typeof apixHandler>,
) => {
  return apixHandler<void>(
    {
      url: `/apix/v2/Users/${userId}`,
      method: "PATCH",
      headers: { "Content-Type": "application/merge-patch+json" },
      data: idpUserUpdateRequest,
    },
    options,
  );
};

export const getUsersByUserIdPatchV2MutationOptions = <
  TError = ErrorType<BadRequestResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof usersByUserIdPatchV2>>,
    TError,
    { userId: number; data: BodyType<IdpUserUpdateRequest> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof usersByUserIdPatchV2>>,
  TError,
  { userId: number; data: BodyType<IdpUserUpdateRequest> },
  TContext
> => {
  const mutationKey = ["usersByUserIdPatchV2"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof usersByUserIdPatchV2>>,
    { userId: number; data: BodyType<IdpUserUpdateRequest> }
  > = (props) => {
    const { userId, data } = props ?? {};

    return usersByUserIdPatchV2(userId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UsersByUserIdPatchV2MutationResult = NonNullable<
  Awaited<ReturnType<typeof usersByUserIdPatchV2>>
>;
export type UsersByUserIdPatchV2MutationBody = BodyType<IdpUserUpdateRequest>;
export type UsersByUserIdPatchV2MutationError = ErrorType<BadRequestResponse>;

export const useUsersByUserIdPatchV2 = <
  TError = ErrorType<BadRequestResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof usersByUserIdPatchV2>>,
    TError,
    { userId: number; data: BodyType<IdpUserUpdateRequest> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationResult<
  Awaited<ReturnType<typeof usersByUserIdPatchV2>>,
  TError,
  { userId: number; data: BodyType<IdpUserUpdateRequest> },
  TContext
> => {
  const mutationOptions = getUsersByUserIdPatchV2MutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * **Authorization**: `machine-to-machine-bearer`


**Authentication**: `auth0`


**Policy**: `UserCredentialsWrite`


**Stability Level**: `stable`
 */
export const usersAuthStoreForUsernameGetV2 = (
  params?: UsersAuthStoreForUsernameGetV2Params,
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<AuthStoreForUsernameResponse>(
    {
      url: `/apix/v2/Users/AuthStoreForUsername`,
      method: "GET",
      params,
      signal,
    },
    options,
  );
};

export const getUsersAuthStoreForUsernameGetV2QueryKey = (
  params?: UsersAuthStoreForUsernameGetV2Params,
) => {
  return [
    `/apix/v2/Users/AuthStoreForUsername`,
    ...(params ? [params] : []),
  ] as const;
};

export const getUsersAuthStoreForUsernameGetV2QueryOptions = <
  TData = Awaited<ReturnType<typeof usersAuthStoreForUsernameGetV2>>,
  TError = ErrorType<unknown>,
>(
  params?: UsersAuthStoreForUsernameGetV2Params,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof usersAuthStoreForUsernameGetV2>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apixHandler>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getUsersAuthStoreForUsernameGetV2QueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof usersAuthStoreForUsernameGetV2>>
  > = ({ signal }) =>
    usersAuthStoreForUsernameGetV2(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof usersAuthStoreForUsernameGetV2>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type UsersAuthStoreForUsernameGetV2QueryResult = NonNullable<
  Awaited<ReturnType<typeof usersAuthStoreForUsernameGetV2>>
>;
export type UsersAuthStoreForUsernameGetV2QueryError = ErrorType<unknown>;

export function useUsersAuthStoreForUsernameGetV2<
  TData = Awaited<ReturnType<typeof usersAuthStoreForUsernameGetV2>>,
  TError = ErrorType<unknown>,
>(
  params?: UsersAuthStoreForUsernameGetV2Params,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof usersAuthStoreForUsernameGetV2>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apixHandler>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getUsersAuthStoreForUsernameGetV2QueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * **Authorization**: `machine-to-machine-bearer`


**Authentication**: `auth0`


**Policy**: `ExternalService`


**Stability Level**: `stable`
 * @summary Gets a list of ExternalUserResponse objects given a users external id
 */
export const usersGetExternalCompanyInformationGetV2 = (
  params?: UsersGetExternalCompanyInformationGetV2Params,
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<ExternalCompanyInformationResponse>(
    {
      url: `/apix/v2/Users/GetExternalCompanyInformation`,
      method: "GET",
      params,
      signal,
    },
    options,
  );
};

export const getUsersGetExternalCompanyInformationGetV2QueryKey = (
  params?: UsersGetExternalCompanyInformationGetV2Params,
) => {
  return [
    `/apix/v2/Users/GetExternalCompanyInformation`,
    ...(params ? [params] : []),
  ] as const;
};

export const getUsersGetExternalCompanyInformationGetV2QueryOptions = <
  TData = Awaited<ReturnType<typeof usersGetExternalCompanyInformationGetV2>>,
  TError = ErrorType<unknown>,
>(
  params?: UsersGetExternalCompanyInformationGetV2Params,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof usersGetExternalCompanyInformationGetV2>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apixHandler>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getUsersGetExternalCompanyInformationGetV2QueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof usersGetExternalCompanyInformationGetV2>>
  > = ({ signal }) =>
    usersGetExternalCompanyInformationGetV2(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof usersGetExternalCompanyInformationGetV2>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type UsersGetExternalCompanyInformationGetV2QueryResult = NonNullable<
  Awaited<ReturnType<typeof usersGetExternalCompanyInformationGetV2>>
>;
export type UsersGetExternalCompanyInformationGetV2QueryError =
  ErrorType<unknown>;

/**
 * @summary Gets a list of ExternalUserResponse objects given a users external id
 */

export function useUsersGetExternalCompanyInformationGetV2<
  TData = Awaited<ReturnType<typeof usersGetExternalCompanyInformationGetV2>>,
  TError = ErrorType<unknown>,
>(
  params?: UsersGetExternalCompanyInformationGetV2Params,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof usersGetExternalCompanyInformationGetV2>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apixHandler>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getUsersGetExternalCompanyInformationGetV2QueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * **Stability Level**: `stable`
 */
export const usersActivationByShareTokenGetV2 = (
  shareToken: string,
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<GetUserActivationResponse>(
    { url: `/apix/v2/Users/activation/${shareToken}`, method: "GET", signal },
    options,
  );
};

export const getUsersActivationByShareTokenGetV2QueryKey = (
  shareToken?: string,
) => {
  return [`/apix/v2/Users/activation/${shareToken}`] as const;
};

export const getUsersActivationByShareTokenGetV2QueryOptions = <
  TData = Awaited<ReturnType<typeof usersActivationByShareTokenGetV2>>,
  TError = ErrorType<unknown>,
>(
  shareToken: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof usersActivationByShareTokenGetV2>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apixHandler>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getUsersActivationByShareTokenGetV2QueryKey(shareToken);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof usersActivationByShareTokenGetV2>>
  > = ({ signal }) =>
    usersActivationByShareTokenGetV2(shareToken, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!shareToken,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof usersActivationByShareTokenGetV2>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type UsersActivationByShareTokenGetV2QueryResult = NonNullable<
  Awaited<ReturnType<typeof usersActivationByShareTokenGetV2>>
>;
export type UsersActivationByShareTokenGetV2QueryError = ErrorType<unknown>;

export function useUsersActivationByShareTokenGetV2<
  TData = Awaited<ReturnType<typeof usersActivationByShareTokenGetV2>>,
  TError = ErrorType<unknown>,
>(
  shareToken: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof usersActivationByShareTokenGetV2>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apixHandler>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getUsersActivationByShareTokenGetV2QueryOptions(
    shareToken,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `draft`
 */
export const usersChangeEmailByOrgLinkIDPostV2 = (
  orgLinkID: number,
  changeEmailRequest: BodyType<ChangeEmailRequest>,
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<ChangeEmailResponse>(
    {
      url: `/apix/v2/Users/change-email/${orgLinkID}`,
      method: "POST",
      headers: { "Content-Type": "application/merge-patch+json" },
      data: changeEmailRequest,
      signal,
    },
    options,
  );
};

export const getUsersChangeEmailByOrgLinkIDPostV2MutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof usersChangeEmailByOrgLinkIDPostV2>>,
    TError,
    { orgLinkID: number; data: BodyType<ChangeEmailRequest> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof usersChangeEmailByOrgLinkIDPostV2>>,
  TError,
  { orgLinkID: number; data: BodyType<ChangeEmailRequest> },
  TContext
> => {
  const mutationKey = ["usersChangeEmailByOrgLinkIDPostV2"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof usersChangeEmailByOrgLinkIDPostV2>>,
    { orgLinkID: number; data: BodyType<ChangeEmailRequest> }
  > = (props) => {
    const { orgLinkID, data } = props ?? {};

    return usersChangeEmailByOrgLinkIDPostV2(orgLinkID, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UsersChangeEmailByOrgLinkIDPostV2MutationResult = NonNullable<
  Awaited<ReturnType<typeof usersChangeEmailByOrgLinkIDPostV2>>
>;
export type UsersChangeEmailByOrgLinkIDPostV2MutationBody =
  BodyType<ChangeEmailRequest>;
export type UsersChangeEmailByOrgLinkIDPostV2MutationError = ErrorType<unknown>;

export const useUsersChangeEmailByOrgLinkIDPostV2 = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof usersChangeEmailByOrgLinkIDPostV2>>,
    TError,
    { orgLinkID: number; data: BodyType<ChangeEmailRequest> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationResult<
  Awaited<ReturnType<typeof usersChangeEmailByOrgLinkIDPostV2>>,
  TError,
  { orgLinkID: number; data: BodyType<ChangeEmailRequest> },
  TContext
> => {
  const mutationOptions =
    getUsersChangeEmailByOrgLinkIDPostV2MutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `stable`
 */
export const usersCustomFieldsGetV2 = (
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<InternalUsersSetupResponse>(
    { url: `/apix/v2/Users/custom-fields`, method: "GET", signal },
    options,
  );
};

export const getUsersCustomFieldsGetV2QueryKey = () => {
  return [`/apix/v2/Users/custom-fields`] as const;
};

export const getUsersCustomFieldsGetV2QueryOptions = <
  TData = Awaited<ReturnType<typeof usersCustomFieldsGetV2>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof usersCustomFieldsGetV2>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof apixHandler>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getUsersCustomFieldsGetV2QueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof usersCustomFieldsGetV2>>
  > = ({ signal }) => usersCustomFieldsGetV2(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof usersCustomFieldsGetV2>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type UsersCustomFieldsGetV2QueryResult = NonNullable<
  Awaited<ReturnType<typeof usersCustomFieldsGetV2>>
>;
export type UsersCustomFieldsGetV2QueryError = ErrorType<unknown>;

export function useUsersCustomFieldsGetV2<
  TData = Awaited<ReturnType<typeof usersCustomFieldsGetV2>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof usersCustomFieldsGetV2>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getUsersCustomFieldsGetV2QueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * **Stability Level**: `stable`
 */
export const usersSmsVerifyByShareTokenGetV2 = (
  shareToken: string,
  params?: UsersSmsVerifyByShareTokenGetV2Params,
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<LockoutInformationResponse>(
    {
      url: `/apix/v2/Users/sms-verify/${shareToken}`,
      method: "GET",
      params,
      signal,
    },
    options,
  );
};

export const getUsersSmsVerifyByShareTokenGetV2QueryKey = (
  shareToken?: string,
  params?: UsersSmsVerifyByShareTokenGetV2Params,
) => {
  return [
    `/apix/v2/Users/sms-verify/${shareToken}`,
    ...(params ? [params] : []),
  ] as const;
};

export const getUsersSmsVerifyByShareTokenGetV2QueryOptions = <
  TData = Awaited<ReturnType<typeof usersSmsVerifyByShareTokenGetV2>>,
  TError = ErrorType<unknown>,
>(
  shareToken: string,
  params?: UsersSmsVerifyByShareTokenGetV2Params,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof usersSmsVerifyByShareTokenGetV2>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apixHandler>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getUsersSmsVerifyByShareTokenGetV2QueryKey(shareToken, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof usersSmsVerifyByShareTokenGetV2>>
  > = ({ signal }) =>
    usersSmsVerifyByShareTokenGetV2(shareToken, params, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!shareToken,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof usersSmsVerifyByShareTokenGetV2>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type UsersSmsVerifyByShareTokenGetV2QueryResult = NonNullable<
  Awaited<ReturnType<typeof usersSmsVerifyByShareTokenGetV2>>
>;
export type UsersSmsVerifyByShareTokenGetV2QueryError = ErrorType<unknown>;

export function useUsersSmsVerifyByShareTokenGetV2<
  TData = Awaited<ReturnType<typeof usersSmsVerifyByShareTokenGetV2>>,
  TError = ErrorType<unknown>,
>(
  shareToken: string,
  params?: UsersSmsVerifyByShareTokenGetV2Params,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof usersSmsVerifyByShareTokenGetV2>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apixHandler>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getUsersSmsVerifyByShareTokenGetV2QueryOptions(
    shareToken,
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * **Stability Level**: `stable`
 */
export const usersSmsVerifyByShareTokenPostV2 = (
  shareToken: string,
  params?: UsersSmsVerifyByShareTokenPostV2Params,
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<LockoutVerificationResponse>(
    {
      url: `/apix/v2/Users/sms-verify/${shareToken}`,
      method: "POST",
      params,
      signal,
    },
    options,
  );
};

export const getUsersSmsVerifyByShareTokenPostV2MutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof usersSmsVerifyByShareTokenPostV2>>,
    TError,
    { shareToken: string; params?: UsersSmsVerifyByShareTokenPostV2Params },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof usersSmsVerifyByShareTokenPostV2>>,
  TError,
  { shareToken: string; params?: UsersSmsVerifyByShareTokenPostV2Params },
  TContext
> => {
  const mutationKey = ["usersSmsVerifyByShareTokenPostV2"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof usersSmsVerifyByShareTokenPostV2>>,
    { shareToken: string; params?: UsersSmsVerifyByShareTokenPostV2Params }
  > = (props) => {
    const { shareToken, params } = props ?? {};

    return usersSmsVerifyByShareTokenPostV2(shareToken, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UsersSmsVerifyByShareTokenPostV2MutationResult = NonNullable<
  Awaited<ReturnType<typeof usersSmsVerifyByShareTokenPostV2>>
>;

export type UsersSmsVerifyByShareTokenPostV2MutationError = ErrorType<unknown>;

export const useUsersSmsVerifyByShareTokenPostV2 = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof usersSmsVerifyByShareTokenPostV2>>,
    TError,
    { shareToken: string; params?: UsersSmsVerifyByShareTokenPostV2Params },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationResult<
  Awaited<ReturnType<typeof usersSmsVerifyByShareTokenPostV2>>,
  TError,
  { shareToken: string; params?: UsersSmsVerifyByShareTokenPostV2Params },
  TContext
> => {
  const mutationOptions =
    getUsersSmsVerifyByShareTokenPostV2MutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * **Stability Level**: `stable`
 */
export const usersPhoneVerifyByShareTokenGetV2 = (
  shareToken: string,
  params?: UsersPhoneVerifyByShareTokenGetV2Params,
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<LockoutInformationResponse>(
    {
      url: `/apix/v2/Users/phone-verify/${shareToken}`,
      method: "GET",
      params,
      signal,
    },
    options,
  );
};

export const getUsersPhoneVerifyByShareTokenGetV2QueryKey = (
  shareToken?: string,
  params?: UsersPhoneVerifyByShareTokenGetV2Params,
) => {
  return [
    `/apix/v2/Users/phone-verify/${shareToken}`,
    ...(params ? [params] : []),
  ] as const;
};

export const getUsersPhoneVerifyByShareTokenGetV2QueryOptions = <
  TData = Awaited<ReturnType<typeof usersPhoneVerifyByShareTokenGetV2>>,
  TError = ErrorType<unknown>,
>(
  shareToken: string,
  params?: UsersPhoneVerifyByShareTokenGetV2Params,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof usersPhoneVerifyByShareTokenGetV2>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apixHandler>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getUsersPhoneVerifyByShareTokenGetV2QueryKey(shareToken, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof usersPhoneVerifyByShareTokenGetV2>>
  > = ({ signal }) =>
    usersPhoneVerifyByShareTokenGetV2(
      shareToken,
      params,
      requestOptions,
      signal,
    );

  return {
    queryKey,
    queryFn,
    enabled: !!shareToken,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof usersPhoneVerifyByShareTokenGetV2>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type UsersPhoneVerifyByShareTokenGetV2QueryResult = NonNullable<
  Awaited<ReturnType<typeof usersPhoneVerifyByShareTokenGetV2>>
>;
export type UsersPhoneVerifyByShareTokenGetV2QueryError = ErrorType<unknown>;

export function useUsersPhoneVerifyByShareTokenGetV2<
  TData = Awaited<ReturnType<typeof usersPhoneVerifyByShareTokenGetV2>>,
  TError = ErrorType<unknown>,
>(
  shareToken: string,
  params?: UsersPhoneVerifyByShareTokenGetV2Params,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof usersPhoneVerifyByShareTokenGetV2>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apixHandler>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getUsersPhoneVerifyByShareTokenGetV2QueryOptions(
    shareToken,
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * **Stability Level**: `stable`
 */
export const usersPhoneVerifyByShareTokenPostV2 = (
  shareToken: string,
  params?: UsersPhoneVerifyByShareTokenPostV2Params,
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<LockoutVerificationResponse>(
    {
      url: `/apix/v2/Users/phone-verify/${shareToken}`,
      method: "POST",
      params,
      signal,
    },
    options,
  );
};

export const getUsersPhoneVerifyByShareTokenPostV2MutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof usersPhoneVerifyByShareTokenPostV2>>,
    TError,
    { shareToken: string; params?: UsersPhoneVerifyByShareTokenPostV2Params },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof usersPhoneVerifyByShareTokenPostV2>>,
  TError,
  { shareToken: string; params?: UsersPhoneVerifyByShareTokenPostV2Params },
  TContext
> => {
  const mutationKey = ["usersPhoneVerifyByShareTokenPostV2"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof usersPhoneVerifyByShareTokenPostV2>>,
    { shareToken: string; params?: UsersPhoneVerifyByShareTokenPostV2Params }
  > = (props) => {
    const { shareToken, params } = props ?? {};

    return usersPhoneVerifyByShareTokenPostV2(
      shareToken,
      params,
      requestOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type UsersPhoneVerifyByShareTokenPostV2MutationResult = NonNullable<
  Awaited<ReturnType<typeof usersPhoneVerifyByShareTokenPostV2>>
>;

export type UsersPhoneVerifyByShareTokenPostV2MutationError =
  ErrorType<unknown>;

export const useUsersPhoneVerifyByShareTokenPostV2 = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof usersPhoneVerifyByShareTokenPostV2>>,
    TError,
    { shareToken: string; params?: UsersPhoneVerifyByShareTokenPostV2Params },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationResult<
  Awaited<ReturnType<typeof usersPhoneVerifyByShareTokenPostV2>>,
  TError,
  { shareToken: string; params?: UsersPhoneVerifyByShareTokenPostV2Params },
  TContext
> => {
  const mutationOptions =
    getUsersPhoneVerifyByShareTokenPostV2MutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `draft`
 * @summary Request a password reset email for the currently authenticated user. Self-only: the
target email is taken from the authenticated session and cannot be overridden by the
caller.
 */
export const usersMeRequestPasswordResetPostV2 = (
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<void>(
    { url: `/apix/v2/Users/me/request-password-reset`, method: "POST", signal },
    options,
  );
};

export const getUsersMeRequestPasswordResetPostV2MutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof usersMeRequestPasswordResetPostV2>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof usersMeRequestPasswordResetPostV2>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["usersMeRequestPasswordResetPostV2"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof usersMeRequestPasswordResetPostV2>>,
    void
  > = () => {
    return usersMeRequestPasswordResetPostV2(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UsersMeRequestPasswordResetPostV2MutationResult = NonNullable<
  Awaited<ReturnType<typeof usersMeRequestPasswordResetPostV2>>
>;

export type UsersMeRequestPasswordResetPostV2MutationError = ErrorType<void>;

/**
 * @summary Request a password reset email for the currently authenticated user. Self-only: the
target email is taken from the authenticated session and cannot be overridden by the
caller.
 */
export const useUsersMeRequestPasswordResetPostV2 = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof usersMeRequestPasswordResetPostV2>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationResult<
  Awaited<ReturnType<typeof usersMeRequestPasswordResetPostV2>>,
  TError,
  void,
  TContext
> => {
  const mutationOptions =
    getUsersMeRequestPasswordResetPostV2MutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `draft` 

 The current decisions are served on the global context payload
(`GET /v2/context/global` → `userInfo.optIns`), so there is no dedicated GET
and reading them costs no extra request on page load.

The feature is in the body rather than the route: opt-ins are added and removed over
time, so an identifier here would not durably reference the same thing.
Opting out stores an explicit decision rather than clearing the record, so that
"tried it and turned it off" stays distinguishable from "never decided".
 * @summary Record the currently authenticated user's decision for a single opt-in feature.
Self-only: the user is taken from the authenticated session and cannot be overridden
by the caller.
 */
export const usersOptInPostV2 = (
  userOptInRequest: BodyType<UserOptInRequest>,
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<void>(
    {
      url: `/apix/v2/Users/opt-in`,
      method: "POST",
      headers: { "Content-Type": "application/merge-patch+json" },
      data: userOptInRequest,
      signal,
    },
    options,
  );
};

export const getUsersOptInPostV2MutationOptions = <
  TError = ErrorType<void | ProblemDetails>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof usersOptInPostV2>>,
    TError,
    { data: BodyType<UserOptInRequest> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof usersOptInPostV2>>,
  TError,
  { data: BodyType<UserOptInRequest> },
  TContext
> => {
  const mutationKey = ["usersOptInPostV2"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof usersOptInPostV2>>,
    { data: BodyType<UserOptInRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return usersOptInPostV2(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UsersOptInPostV2MutationResult = NonNullable<
  Awaited<ReturnType<typeof usersOptInPostV2>>
>;
export type UsersOptInPostV2MutationBody = BodyType<UserOptInRequest>;
export type UsersOptInPostV2MutationError = ErrorType<void | ProblemDetails>;

/**
 * @summary Record the currently authenticated user's decision for a single opt-in feature.
Self-only: the user is taken from the authenticated session and cannot be overridden
by the caller.
 */
export const useUsersOptInPostV2 = <
  TError = ErrorType<void | ProblemDetails>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof usersOptInPostV2>>,
    TError,
    { data: BodyType<UserOptInRequest> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationResult<
  Awaited<ReturnType<typeof usersOptInPostV2>>,
  TError,
  { data: BodyType<UserOptInRequest> },
  TContext
> => {
  const mutationOptions = getUsersOptInPostV2MutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * **Authorization**: `user-bearer`


**Authentication**: `auth0` | `LegacyBearer`


**Policy**: `ExternalUser`


**Stability Level**: `draft`
 * @summary Get user information for Buildertrend Community
 */
export const usersCommunityUserExternalGetV2 = (
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<CommunityExternalUserResponse>(
    { url: `/apix/v2/Users/community-user-external`, method: "GET", signal },
    options,
  );
};

export const getUsersCommunityUserExternalGetV2QueryKey = () => {
  return [`/apix/v2/Users/community-user-external`] as const;
};

export const getUsersCommunityUserExternalGetV2QueryOptions = <
  TData = Awaited<ReturnType<typeof usersCommunityUserExternalGetV2>>,
  TError = ErrorType<void>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof usersCommunityUserExternalGetV2>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof apixHandler>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getUsersCommunityUserExternalGetV2QueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof usersCommunityUserExternalGetV2>>
  > = ({ signal }) => usersCommunityUserExternalGetV2(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof usersCommunityUserExternalGetV2>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type UsersCommunityUserExternalGetV2QueryResult = NonNullable<
  Awaited<ReturnType<typeof usersCommunityUserExternalGetV2>>
>;
export type UsersCommunityUserExternalGetV2QueryError = ErrorType<void>;

/**
 * @summary Get user information for Buildertrend Community
 */

export function useUsersCommunityUserExternalGetV2<
  TData = Awaited<ReturnType<typeof usersCommunityUserExternalGetV2>>,
  TError = ErrorType<void>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof usersCommunityUserExternalGetV2>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getUsersCommunityUserExternalGetV2QueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `draft`
 */
export const usersBulkInvitePostV2 = (
  bulkActionRequest: BodyType<BulkActionRequest>,
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<BulkActionResponse>(
    {
      url: `/apix/v2/Users/bulk-invite`,
      method: "POST",
      headers: { "Content-Type": "application/merge-patch+json" },
      data: bulkActionRequest,
      signal,
    },
    options,
  );
};

export const getUsersBulkInvitePostV2MutationOptions = <
  TError = ErrorType<BadRequestResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof usersBulkInvitePostV2>>,
    TError,
    { data: BodyType<BulkActionRequest> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof usersBulkInvitePostV2>>,
  TError,
  { data: BodyType<BulkActionRequest> },
  TContext
> => {
  const mutationKey = ["usersBulkInvitePostV2"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof usersBulkInvitePostV2>>,
    { data: BodyType<BulkActionRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return usersBulkInvitePostV2(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UsersBulkInvitePostV2MutationResult = NonNullable<
  Awaited<ReturnType<typeof usersBulkInvitePostV2>>
>;
export type UsersBulkInvitePostV2MutationBody = BodyType<BulkActionRequest>;
export type UsersBulkInvitePostV2MutationError = ErrorType<BadRequestResponse>;

export const useUsersBulkInvitePostV2 = <
  TError = ErrorType<BadRequestResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof usersBulkInvitePostV2>>,
    TError,
    { data: BodyType<BulkActionRequest> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationResult<
  Awaited<ReturnType<typeof usersBulkInvitePostV2>>,
  TError,
  { data: BodyType<BulkActionRequest> },
  TContext
> => {
  const mutationOptions = getUsersBulkInvitePostV2MutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `draft`
 */
export const usersBulkDeleteDeleteV2 = (
  bulkActionRequest: BodyType<BulkActionRequest>,
  options?: SecondParameter<typeof apixHandler>,
) => {
  return apixHandler<BulkActionResponse>(
    {
      url: `/apix/v2/Users/bulk-delete`,
      method: "DELETE",
      headers: { "Content-Type": "application/merge-patch+json" },
      data: bulkActionRequest,
    },
    options,
  );
};

export const getUsersBulkDeleteDeleteV2MutationOptions = <
  TError = ErrorType<BadRequestResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof usersBulkDeleteDeleteV2>>,
    TError,
    { data: BodyType<BulkActionRequest> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof usersBulkDeleteDeleteV2>>,
  TError,
  { data: BodyType<BulkActionRequest> },
  TContext
> => {
  const mutationKey = ["usersBulkDeleteDeleteV2"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof usersBulkDeleteDeleteV2>>,
    { data: BodyType<BulkActionRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return usersBulkDeleteDeleteV2(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UsersBulkDeleteDeleteV2MutationResult = NonNullable<
  Awaited<ReturnType<typeof usersBulkDeleteDeleteV2>>
>;
export type UsersBulkDeleteDeleteV2MutationBody = BodyType<BulkActionRequest>;
export type UsersBulkDeleteDeleteV2MutationError =
  ErrorType<BadRequestResponse>;

export const useUsersBulkDeleteDeleteV2 = <
  TError = ErrorType<BadRequestResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof usersBulkDeleteDeleteV2>>,
    TError,
    { data: BodyType<BulkActionRequest> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationResult<
  Awaited<ReturnType<typeof usersBulkDeleteDeleteV2>>,
  TError,
  { data: BodyType<BulkActionRequest> },
  TContext
> => {
  const mutationOptions = getUsersBulkDeleteDeleteV2MutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `draft`
 * @summary Request an 2FA/MFA enrollment via Auth0. Self-only
 */
export const usersMeMfaEnrollmentPostV2 = (
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<Auth0MfaEnrollmentTicketResponse>(
    { url: `/apix/v2/Users/me/mfa-enrollment`, method: "POST", signal },
    options,
  );
};

export const getUsersMeMfaEnrollmentPostV2MutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof usersMeMfaEnrollmentPostV2>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof usersMeMfaEnrollmentPostV2>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["usersMeMfaEnrollmentPostV2"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof usersMeMfaEnrollmentPostV2>>,
    void
  > = () => {
    return usersMeMfaEnrollmentPostV2(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UsersMeMfaEnrollmentPostV2MutationResult = NonNullable<
  Awaited<ReturnType<typeof usersMeMfaEnrollmentPostV2>>
>;

export type UsersMeMfaEnrollmentPostV2MutationError = ErrorType<void>;

/**
 * @summary Request an 2FA/MFA enrollment via Auth0. Self-only
 */
export const useUsersMeMfaEnrollmentPostV2 = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof usersMeMfaEnrollmentPostV2>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationResult<
  Awaited<ReturnType<typeof usersMeMfaEnrollmentPostV2>>,
  TError,
  void,
  TContext
> => {
  const mutationOptions = getUsersMeMfaEnrollmentPostV2MutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * **Authorization**: `machine-to-machine-bearer`


**Authentication**: `auth0`


**Policy**: `Testing`


**Stability Level**: `stable`
 * @summary This is a testing version of the Clients.WebApi.UsersController.CreateNewUserAsync method
that does not validate the email address, allowing for the creation of users with usernames
that are not valid email addresses.
 */
export const testingUsersPostV2 = (
  userActivationRequest: BodyType<UserActivationRequest>,
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<ActivationResponse>(
    {
      url: `/apix/v2/testing/Users`,
      method: "POST",
      headers: { "Content-Type": "application/merge-patch+json" },
      data: userActivationRequest,
      signal,
    },
    options,
  );
};

export const getTestingUsersPostV2MutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof testingUsersPostV2>>,
    TError,
    { data: BodyType<UserActivationRequest> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof testingUsersPostV2>>,
  TError,
  { data: BodyType<UserActivationRequest> },
  TContext
> => {
  const mutationKey = ["testingUsersPostV2"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof testingUsersPostV2>>,
    { data: BodyType<UserActivationRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return testingUsersPostV2(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type TestingUsersPostV2MutationResult = NonNullable<
  Awaited<ReturnType<typeof testingUsersPostV2>>
>;
export type TestingUsersPostV2MutationBody = BodyType<UserActivationRequest>;
export type TestingUsersPostV2MutationError = ErrorType<unknown>;

/**
 * @summary This is a testing version of the Clients.WebApi.UsersController.CreateNewUserAsync method
that does not validate the email address, allowing for the creation of users with usernames
that are not valid email addresses.
 */
export const useTestingUsersPostV2 = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof testingUsersPostV2>>,
    TError,
    { data: BodyType<UserActivationRequest> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationResult<
  Awaited<ReturnType<typeof testingUsersPostV2>>,
  TError,
  { data: BodyType<UserActivationRequest> },
  TContext
> => {
  const mutationOptions = getTestingUsersPostV2MutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * **Authorization**: `machine-to-machine-bearer`


**Authentication**: `auth0`


**Policy**: `Testing`


**Stability Level**: `draft`
 * @summary Testing-only helper for e2e test cleanup: for each email, finds the associated Users record and
deactivates every active GlobalUser linked to it, freeing up the unique email/username slot.
Idempotent - emails with no matching active GlobalUsers are silently skipped.
 */
export const testingUsersDeactivateGlobalUsersPostV2 = (
  deactivateGlobalUsersByEmailRequest: BodyType<DeactivateGlobalUsersByEmailRequest>,
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<void>(
    {
      url: `/apix/v2/testing/Users/deactivate-global-users`,
      method: "POST",
      headers: { "Content-Type": "application/merge-patch+json" },
      data: deactivateGlobalUsersByEmailRequest,
      signal,
    },
    options,
  );
};

export const getTestingUsersDeactivateGlobalUsersPostV2MutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof testingUsersDeactivateGlobalUsersPostV2>>,
    TError,
    { data: BodyType<DeactivateGlobalUsersByEmailRequest> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof testingUsersDeactivateGlobalUsersPostV2>>,
  TError,
  { data: BodyType<DeactivateGlobalUsersByEmailRequest> },
  TContext
> => {
  const mutationKey = ["testingUsersDeactivateGlobalUsersPostV2"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof testingUsersDeactivateGlobalUsersPostV2>>,
    { data: BodyType<DeactivateGlobalUsersByEmailRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return testingUsersDeactivateGlobalUsersPostV2(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type TestingUsersDeactivateGlobalUsersPostV2MutationResult = NonNullable<
  Awaited<ReturnType<typeof testingUsersDeactivateGlobalUsersPostV2>>
>;
export type TestingUsersDeactivateGlobalUsersPostV2MutationBody =
  BodyType<DeactivateGlobalUsersByEmailRequest>;
export type TestingUsersDeactivateGlobalUsersPostV2MutationError =
  ErrorType<unknown>;

/**
 * @summary Testing-only helper for e2e test cleanup: for each email, finds the associated Users record and
deactivates every active GlobalUser linked to it, freeing up the unique email/username slot.
Idempotent - emails with no matching active GlobalUsers are silently skipped.
 */
export const useTestingUsersDeactivateGlobalUsersPostV2 = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof testingUsersDeactivateGlobalUsersPostV2>>,
    TError,
    { data: BodyType<DeactivateGlobalUsersByEmailRequest> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationResult<
  Awaited<ReturnType<typeof testingUsersDeactivateGlobalUsersPostV2>>,
  TError,
  { data: BodyType<DeactivateGlobalUsersByEmailRequest> },
  TContext
> => {
  const mutationOptions =
    getTestingUsersDeactivateGlobalUsersPostV2MutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `BTAdminCookie` | `LegacyBearer` | `Session`


**Policy**: `BTAdminUser`


**Stability Level**: `stable`
 */
export const adminUsersUsernameSearchGetV2 = (
  params?: AdminUsersUsernameSearchGetV2Params,
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<UsernameLookupContract>(
    {
      url: `/apix/v2/admin/Users/username-search`,
      method: "GET",
      params,
      signal,
    },
    options,
  );
};

export const getAdminUsersUsernameSearchGetV2QueryKey = (
  params?: AdminUsersUsernameSearchGetV2Params,
) => {
  return [
    `/apix/v2/admin/Users/username-search`,
    ...(params ? [params] : []),
  ] as const;
};

export const getAdminUsersUsernameSearchGetV2QueryOptions = <
  TData = Awaited<ReturnType<typeof adminUsersUsernameSearchGetV2>>,
  TError = ErrorType<unknown>,
>(
  params?: AdminUsersUsernameSearchGetV2Params,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof adminUsersUsernameSearchGetV2>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apixHandler>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getAdminUsersUsernameSearchGetV2QueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof adminUsersUsernameSearchGetV2>>
  > = ({ signal }) =>
    adminUsersUsernameSearchGetV2(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof adminUsersUsernameSearchGetV2>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type AdminUsersUsernameSearchGetV2QueryResult = NonNullable<
  Awaited<ReturnType<typeof adminUsersUsernameSearchGetV2>>
>;
export type AdminUsersUsernameSearchGetV2QueryError = ErrorType<unknown>;

export function useAdminUsersUsernameSearchGetV2<
  TData = Awaited<ReturnType<typeof adminUsersUsernameSearchGetV2>>,
  TError = ErrorType<unknown>,
>(
  params?: AdminUsersUsernameSearchGetV2Params,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof adminUsersUsernameSearchGetV2>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apixHandler>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getAdminUsersUsernameSearchGetV2QueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `BTAdminCookie` | `LegacyBearer` | `Session`


**Policy**: `BTAdminUser`


**Stability Level**: `stable`
 */
export const adminUsersChangeUsernamePutV2 = (
  changeUsernameRequest: BodyType<ChangeUsernameRequest>,
  options?: SecondParameter<typeof apixHandler>,
) => {
  return apixHandler<ChangeUsernameContract>(
    {
      url: `/apix/v2/admin/Users/change-username`,
      method: "PUT",
      headers: { "Content-Type": "application/merge-patch+json" },
      data: changeUsernameRequest,
    },
    options,
  );
};

export const getAdminUsersChangeUsernamePutV2MutationOptions = <
  TError = ErrorType<BadRequestResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminUsersChangeUsernamePutV2>>,
    TError,
    { data: BodyType<ChangeUsernameRequest> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminUsersChangeUsernamePutV2>>,
  TError,
  { data: BodyType<ChangeUsernameRequest> },
  TContext
> => {
  const mutationKey = ["adminUsersChangeUsernamePutV2"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminUsersChangeUsernamePutV2>>,
    { data: BodyType<ChangeUsernameRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return adminUsersChangeUsernamePutV2(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminUsersChangeUsernamePutV2MutationResult = NonNullable<
  Awaited<ReturnType<typeof adminUsersChangeUsernamePutV2>>
>;
export type AdminUsersChangeUsernamePutV2MutationBody =
  BodyType<ChangeUsernameRequest>;
export type AdminUsersChangeUsernamePutV2MutationError =
  ErrorType<BadRequestResponse>;

export const useAdminUsersChangeUsernamePutV2 = <
  TError = ErrorType<BadRequestResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminUsersChangeUsernamePutV2>>,
    TError,
    { data: BodyType<ChangeUsernameRequest> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationResult<
  Awaited<ReturnType<typeof adminUsersChangeUsernamePutV2>>,
  TError,
  { data: BodyType<ChangeUsernameRequest> },
  TContext
> => {
  const mutationOptions =
    getAdminUsersChangeUsernamePutV2MutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `BTAdminCookie` | `LegacyBearer` | `Session`


**Policy**: `BTAdminUser`


**Stability Level**: `draft`
 */
export const adminUsersSendInvitationPostV2 = (
  sendUserInvitationRequest: BodyType<SendUserInvitationRequest>,
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<SendUserInvitationContract>(
    {
      url: `/apix/v2/admin/Users/send-invitation`,
      method: "POST",
      headers: { "Content-Type": "application/merge-patch+json" },
      data: sendUserInvitationRequest,
      signal,
    },
    options,
  );
};

export const getAdminUsersSendInvitationPostV2MutationOptions = <
  TError = ErrorType<BadRequestResponse | ForbiddenResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminUsersSendInvitationPostV2>>,
    TError,
    { data: BodyType<SendUserInvitationRequest> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminUsersSendInvitationPostV2>>,
  TError,
  { data: BodyType<SendUserInvitationRequest> },
  TContext
> => {
  const mutationKey = ["adminUsersSendInvitationPostV2"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminUsersSendInvitationPostV2>>,
    { data: BodyType<SendUserInvitationRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return adminUsersSendInvitationPostV2(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminUsersSendInvitationPostV2MutationResult = NonNullable<
  Awaited<ReturnType<typeof adminUsersSendInvitationPostV2>>
>;
export type AdminUsersSendInvitationPostV2MutationBody =
  BodyType<SendUserInvitationRequest>;
export type AdminUsersSendInvitationPostV2MutationError = ErrorType<
  BadRequestResponse | ForbiddenResponse
>;

export const useAdminUsersSendInvitationPostV2 = <
  TError = ErrorType<BadRequestResponse | ForbiddenResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminUsersSendInvitationPostV2>>,
    TError,
    { data: BodyType<SendUserInvitationRequest> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationResult<
  Awaited<ReturnType<typeof adminUsersSendInvitationPostV2>>,
  TError,
  { data: BodyType<SendUserInvitationRequest> },
  TContext
> => {
  const mutationOptions =
    getAdminUsersSendInvitationPostV2MutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `BTAdminCookie` | `LegacyBearer` | `Session`


**Policy**: `BTAdminUser`


**Stability Level**: `stable`
 */
export const adminUsersOrgLinkUsersGetV2 = (
  params?: AdminUsersOrgLinkUsersGetV2Params,
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<OrgLinkUsersResponse>(
    { url: `/apix/v2/admin/Users/OrgLinkUsers`, method: "GET", params, signal },
    options,
  );
};

export const getAdminUsersOrgLinkUsersGetV2QueryKey = (
  params?: AdminUsersOrgLinkUsersGetV2Params,
) => {
  return [
    `/apix/v2/admin/Users/OrgLinkUsers`,
    ...(params ? [params] : []),
  ] as const;
};

export const getAdminUsersOrgLinkUsersGetV2QueryOptions = <
  TData = Awaited<ReturnType<typeof adminUsersOrgLinkUsersGetV2>>,
  TError = ErrorType<unknown>,
>(
  params?: AdminUsersOrgLinkUsersGetV2Params,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof adminUsersOrgLinkUsersGetV2>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apixHandler>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getAdminUsersOrgLinkUsersGetV2QueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof adminUsersOrgLinkUsersGetV2>>
  > = ({ signal }) =>
    adminUsersOrgLinkUsersGetV2(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof adminUsersOrgLinkUsersGetV2>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type AdminUsersOrgLinkUsersGetV2QueryResult = NonNullable<
  Awaited<ReturnType<typeof adminUsersOrgLinkUsersGetV2>>
>;
export type AdminUsersOrgLinkUsersGetV2QueryError = ErrorType<unknown>;

export function useAdminUsersOrgLinkUsersGetV2<
  TData = Awaited<ReturnType<typeof adminUsersOrgLinkUsersGetV2>>,
  TError = ErrorType<unknown>,
>(
  params?: AdminUsersOrgLinkUsersGetV2Params,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof adminUsersOrgLinkUsersGetV2>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apixHandler>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getAdminUsersOrgLinkUsersGetV2QueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `BTAdminCookie` | `LegacyBearer` | `Session`


**Policy**: `BTAdminUser`


**Stability Level**: `stable`
 */
export const adminUsersInternalUsersGetV2 = (
  params: AdminUsersInternalUsersGetV2Params,
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<InternalUsersResponse>(
    {
      url: `/apix/v2/admin/Users/internal-users`,
      method: "GET",
      params,
      signal,
    },
    options,
  );
};

export const getAdminUsersInternalUsersGetV2QueryKey = (
  params?: AdminUsersInternalUsersGetV2Params,
) => {
  return [
    `/apix/v2/admin/Users/internal-users`,
    ...(params ? [params] : []),
  ] as const;
};

export const getAdminUsersInternalUsersGetV2QueryOptions = <
  TData = Awaited<ReturnType<typeof adminUsersInternalUsersGetV2>>,
  TError = ErrorType<ForbiddenResponse>,
>(
  params: AdminUsersInternalUsersGetV2Params,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof adminUsersInternalUsersGetV2>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apixHandler>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getAdminUsersInternalUsersGetV2QueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof adminUsersInternalUsersGetV2>>
  > = ({ signal }) =>
    adminUsersInternalUsersGetV2(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof adminUsersInternalUsersGetV2>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type AdminUsersInternalUsersGetV2QueryResult = NonNullable<
  Awaited<ReturnType<typeof adminUsersInternalUsersGetV2>>
>;
export type AdminUsersInternalUsersGetV2QueryError =
  ErrorType<ForbiddenResponse>;

export function useAdminUsersInternalUsersGetV2<
  TData = Awaited<ReturnType<typeof adminUsersInternalUsersGetV2>>,
  TError = ErrorType<ForbiddenResponse>,
>(
  params: AdminUsersInternalUsersGetV2Params,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof adminUsersInternalUsersGetV2>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apixHandler>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getAdminUsersInternalUsersGetV2QueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `BTAdminCookie` | `LegacyBearer` | `Session`


**Policy**: `BTAdminUser`


**Stability Level**: `stable`
 */
export const adminUsersSubsGetV2 = (
  params: AdminUsersSubsGetV2Params,
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<SubsResponse>(
    { url: `/apix/v2/admin/Users/subs`, method: "GET", params, signal },
    options,
  );
};

export const getAdminUsersSubsGetV2QueryKey = (
  params?: AdminUsersSubsGetV2Params,
) => {
  return [`/apix/v2/admin/Users/subs`, ...(params ? [params] : [])] as const;
};

export const getAdminUsersSubsGetV2QueryOptions = <
  TData = Awaited<ReturnType<typeof adminUsersSubsGetV2>>,
  TError = ErrorType<ForbiddenResponse>,
>(
  params: AdminUsersSubsGetV2Params,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof adminUsersSubsGetV2>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apixHandler>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getAdminUsersSubsGetV2QueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof adminUsersSubsGetV2>>
  > = ({ signal }) => adminUsersSubsGetV2(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof adminUsersSubsGetV2>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type AdminUsersSubsGetV2QueryResult = NonNullable<
  Awaited<ReturnType<typeof adminUsersSubsGetV2>>
>;
export type AdminUsersSubsGetV2QueryError = ErrorType<ForbiddenResponse>;

export function useAdminUsersSubsGetV2<
  TData = Awaited<ReturnType<typeof adminUsersSubsGetV2>>,
  TError = ErrorType<ForbiddenResponse>,
>(
  params: AdminUsersSubsGetV2Params,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof adminUsersSubsGetV2>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apixHandler>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getAdminUsersSubsGetV2QueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `BTAdminCookie` | `LegacyBearer` | `Session`


**Policy**: `BTAdminUser`


**Stability Level**: `stable`
 */
export const adminUsersSubsDeleteV2 = (
  params: AdminUsersSubsDeleteV2Params,
  options?: SecondParameter<typeof apixHandler>,
) => {
  return apixHandler<void>(
    { url: `/apix/v2/admin/Users/subs`, method: "DELETE", params },
    options,
  );
};

export const getAdminUsersSubsDeleteV2MutationOptions = <
  TError = ErrorType<ForbiddenResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminUsersSubsDeleteV2>>,
    TError,
    { params: AdminUsersSubsDeleteV2Params },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminUsersSubsDeleteV2>>,
  TError,
  { params: AdminUsersSubsDeleteV2Params },
  TContext
> => {
  const mutationKey = ["adminUsersSubsDeleteV2"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminUsersSubsDeleteV2>>,
    { params: AdminUsersSubsDeleteV2Params }
  > = (props) => {
    const { params } = props ?? {};

    return adminUsersSubsDeleteV2(params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminUsersSubsDeleteV2MutationResult = NonNullable<
  Awaited<ReturnType<typeof adminUsersSubsDeleteV2>>
>;

export type AdminUsersSubsDeleteV2MutationError = ErrorType<ForbiddenResponse>;

export const useAdminUsersSubsDeleteV2 = <
  TError = ErrorType<ForbiddenResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminUsersSubsDeleteV2>>,
    TError,
    { params: AdminUsersSubsDeleteV2Params },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationResult<
  Awaited<ReturnType<typeof adminUsersSubsDeleteV2>>,
  TError,
  { params: AdminUsersSubsDeleteV2Params },
  TContext
> => {
  const mutationOptions = getAdminUsersSubsDeleteV2MutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `BTAdminCookie` | `LegacyBearer` | `Session`


**Policy**: `BTAdminUser`


**Stability Level**: `unknown`
 */
export const adminUsersInvitesHasDeactivatedUsersByOrganizationIdGetV2 = (
  organizationId: string,
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<MassInviteUsersForBuilderInfoResponse>(
    {
      url: `/apix/v2/admin/Users/invites/${organizationId}/has-deactivated-users`,
      method: "GET",
      signal,
    },
    options,
  );
};

export const getAdminUsersInvitesHasDeactivatedUsersByOrganizationIdGetV2QueryKey =
  (organizationId?: string) => {
    return [
      `/apix/v2/admin/Users/invites/${organizationId}/has-deactivated-users`,
    ] as const;
  };

export const getAdminUsersInvitesHasDeactivatedUsersByOrganizationIdGetV2QueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof adminUsersInvitesHasDeactivatedUsersByOrganizationIdGetV2
      >
    >,
    TError = ErrorType<unknown>,
  >(
    organizationId: string,
    options?: {
      query?: UseQueryOptions<
        Awaited<
          ReturnType<
            typeof adminUsersInvitesHasDeactivatedUsersByOrganizationIdGetV2
          >
        >,
        TError,
        TData
      >;
      request?: SecondParameter<typeof apixHandler>;
    },
  ) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getAdminUsersInvitesHasDeactivatedUsersByOrganizationIdGetV2QueryKey(
        organizationId,
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof adminUsersInvitesHasDeactivatedUsersByOrganizationIdGetV2
        >
      >
    > = ({ signal }) =>
      adminUsersInvitesHasDeactivatedUsersByOrganizationIdGetV2(
        organizationId,
        requestOptions,
        signal,
      );

    return {
      queryKey,
      queryFn,
      enabled: !!organizationId,
      ...queryOptions,
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof adminUsersInvitesHasDeactivatedUsersByOrganizationIdGetV2
        >
      >,
      TError,
      TData
    > & { queryKey: QueryKey };
  };

export type AdminUsersInvitesHasDeactivatedUsersByOrganizationIdGetV2QueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof adminUsersInvitesHasDeactivatedUsersByOrganizationIdGetV2
      >
    >
  >;
export type AdminUsersInvitesHasDeactivatedUsersByOrganizationIdGetV2QueryError =
  ErrorType<unknown>;

export function useAdminUsersInvitesHasDeactivatedUsersByOrganizationIdGetV2<
  TData = Awaited<
    ReturnType<typeof adminUsersInvitesHasDeactivatedUsersByOrganizationIdGetV2>
  >,
  TError = ErrorType<unknown>,
>(
  organizationId: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<
        ReturnType<
          typeof adminUsersInvitesHasDeactivatedUsersByOrganizationIdGetV2
        >
      >,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apixHandler>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions =
    getAdminUsersInvitesHasDeactivatedUsersByOrganizationIdGetV2QueryOptions(
      organizationId,
      options,
    );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `BTAdminCookie` | `LegacyBearer` | `Session`


**Policy**: `BTAdminUser`


**Stability Level**: `stable`
 */
export const adminUsersInvitesByOrganizationIdPostV2 = (
  organizationId: string,
  massInviteUsersForBuilderRequest: BodyType<MassInviteUsersForBuilderRequest>,
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<MassInviteUsersOnBuilderResponse>(
    {
      url: `/apix/v2/admin/Users/invites/${organizationId}`,
      method: "POST",
      headers: { "Content-Type": "application/merge-patch+json" },
      data: massInviteUsersForBuilderRequest,
      signal,
    },
    options,
  );
};

export const getAdminUsersInvitesByOrganizationIdPostV2MutationOptions = <
  TError = ErrorType<BadRequestResponse | ForbiddenResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminUsersInvitesByOrganizationIdPostV2>>,
    TError,
    {
      organizationId: string;
      data: BodyType<MassInviteUsersForBuilderRequest>;
    },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminUsersInvitesByOrganizationIdPostV2>>,
  TError,
  { organizationId: string; data: BodyType<MassInviteUsersForBuilderRequest> },
  TContext
> => {
  const mutationKey = ["adminUsersInvitesByOrganizationIdPostV2"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminUsersInvitesByOrganizationIdPostV2>>,
    { organizationId: string; data: BodyType<MassInviteUsersForBuilderRequest> }
  > = (props) => {
    const { organizationId, data } = props ?? {};

    return adminUsersInvitesByOrganizationIdPostV2(
      organizationId,
      data,
      requestOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminUsersInvitesByOrganizationIdPostV2MutationResult = NonNullable<
  Awaited<ReturnType<typeof adminUsersInvitesByOrganizationIdPostV2>>
>;
export type AdminUsersInvitesByOrganizationIdPostV2MutationBody =
  BodyType<MassInviteUsersForBuilderRequest>;
export type AdminUsersInvitesByOrganizationIdPostV2MutationError = ErrorType<
  BadRequestResponse | ForbiddenResponse
>;

export const useAdminUsersInvitesByOrganizationIdPostV2 = <
  TError = ErrorType<BadRequestResponse | ForbiddenResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminUsersInvitesByOrganizationIdPostV2>>,
    TError,
    {
      organizationId: string;
      data: BodyType<MassInviteUsersForBuilderRequest>;
    },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationResult<
  Awaited<ReturnType<typeof adminUsersInvitesByOrganizationIdPostV2>>,
  TError,
  { organizationId: string; data: BodyType<MassInviteUsersForBuilderRequest> },
  TContext
> => {
  const mutationOptions =
    getAdminUsersInvitesByOrganizationIdPostV2MutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `BTAdminCookie` | `LegacyBearer` | `Session`


**Policy**: `BTAdminUser`


**Stability Level**: `stable`
 */
export const adminUsersDeactivateByGlobalUserIDPostV2 = (
  globalUserID: number,
  userDeactivationRequest: BodyType<UserDeactivationRequest>,
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<void>(
    {
      url: `/apix/v2/admin/Users/${globalUserID}/deactivate`,
      method: "POST",
      headers: { "Content-Type": "application/merge-patch+json" },
      data: userDeactivationRequest,
      signal,
    },
    options,
  );
};

export const getAdminUsersDeactivateByGlobalUserIDPostV2MutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminUsersDeactivateByGlobalUserIDPostV2>>,
    TError,
    { globalUserID: number; data: BodyType<UserDeactivationRequest> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminUsersDeactivateByGlobalUserIDPostV2>>,
  TError,
  { globalUserID: number; data: BodyType<UserDeactivationRequest> },
  TContext
> => {
  const mutationKey = ["adminUsersDeactivateByGlobalUserIDPostV2"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminUsersDeactivateByGlobalUserIDPostV2>>,
    { globalUserID: number; data: BodyType<UserDeactivationRequest> }
  > = (props) => {
    const { globalUserID, data } = props ?? {};

    return adminUsersDeactivateByGlobalUserIDPostV2(
      globalUserID,
      data,
      requestOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminUsersDeactivateByGlobalUserIDPostV2MutationResult =
  NonNullable<
    Awaited<ReturnType<typeof adminUsersDeactivateByGlobalUserIDPostV2>>
  >;
export type AdminUsersDeactivateByGlobalUserIDPostV2MutationBody =
  BodyType<UserDeactivationRequest>;
export type AdminUsersDeactivateByGlobalUserIDPostV2MutationError =
  ErrorType<unknown>;

export const useAdminUsersDeactivateByGlobalUserIDPostV2 = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminUsersDeactivateByGlobalUserIDPostV2>>,
    TError,
    { globalUserID: number; data: BodyType<UserDeactivationRequest> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationResult<
  Awaited<ReturnType<typeof adminUsersDeactivateByGlobalUserIDPostV2>>,
  TError,
  { globalUserID: number; data: BodyType<UserDeactivationRequest> },
  TContext
> => {
  const mutationOptions =
    getAdminUsersDeactivateByGlobalUserIDPostV2MutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `BTAdminCookie` | `LegacyBearer` | `Session`


**Policy**: `BTAdminUser`


**Stability Level**: `draft`
 */
export const adminUsersImpersonationSetupGetV2 = (
  params?: AdminUsersImpersonationSetupGetV2Params,
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<ImpersonationSetupResponse>(
    {
      url: `/apix/v2/admin/Users/impersonation-setup`,
      method: "GET",
      params,
      signal,
    },
    options,
  );
};

export const getAdminUsersImpersonationSetupGetV2QueryKey = (
  params?: AdminUsersImpersonationSetupGetV2Params,
) => {
  return [
    `/apix/v2/admin/Users/impersonation-setup`,
    ...(params ? [params] : []),
  ] as const;
};

export const getAdminUsersImpersonationSetupGetV2QueryOptions = <
  TData = Awaited<ReturnType<typeof adminUsersImpersonationSetupGetV2>>,
  TError = ErrorType<unknown>,
>(
  params?: AdminUsersImpersonationSetupGetV2Params,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof adminUsersImpersonationSetupGetV2>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apixHandler>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getAdminUsersImpersonationSetupGetV2QueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof adminUsersImpersonationSetupGetV2>>
  > = ({ signal }) =>
    adminUsersImpersonationSetupGetV2(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof adminUsersImpersonationSetupGetV2>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type AdminUsersImpersonationSetupGetV2QueryResult = NonNullable<
  Awaited<ReturnType<typeof adminUsersImpersonationSetupGetV2>>
>;
export type AdminUsersImpersonationSetupGetV2QueryError = ErrorType<unknown>;

export function useAdminUsersImpersonationSetupGetV2<
  TData = Awaited<ReturnType<typeof adminUsersImpersonationSetupGetV2>>,
  TError = ErrorType<unknown>,
>(
  params?: AdminUsersImpersonationSetupGetV2Params,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof adminUsersImpersonationSetupGetV2>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apixHandler>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getAdminUsersImpersonationSetupGetV2QueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `BTAdminCookie` | `LegacyBearer` | `Session`


**Policy**: `BTAdminUser`


**Stability Level**: `stable`
 */
export const adminUsersRoleAssignOrgownerPutV2 = (
  assignOrgOwnerRequest: BodyType<AssignOrgOwnerRequest>,
  options?: SecondParameter<typeof apixHandler>,
) => {
  return apixHandler<void>(
    {
      url: `/apix/v2/admin/Users/role-assign-orgowner`,
      method: "PUT",
      headers: { "Content-Type": "application/merge-patch+json" },
      data: assignOrgOwnerRequest,
    },
    options,
  );
};

export const getAdminUsersRoleAssignOrgownerPutV2MutationOptions = <
  TError = ErrorType<BadRequestResponse | ForbiddenResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminUsersRoleAssignOrgownerPutV2>>,
    TError,
    { data: BodyType<AssignOrgOwnerRequest> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminUsersRoleAssignOrgownerPutV2>>,
  TError,
  { data: BodyType<AssignOrgOwnerRequest> },
  TContext
> => {
  const mutationKey = ["adminUsersRoleAssignOrgownerPutV2"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminUsersRoleAssignOrgownerPutV2>>,
    { data: BodyType<AssignOrgOwnerRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return adminUsersRoleAssignOrgownerPutV2(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminUsersRoleAssignOrgownerPutV2MutationResult = NonNullable<
  Awaited<ReturnType<typeof adminUsersRoleAssignOrgownerPutV2>>
>;
export type AdminUsersRoleAssignOrgownerPutV2MutationBody =
  BodyType<AssignOrgOwnerRequest>;
export type AdminUsersRoleAssignOrgownerPutV2MutationError = ErrorType<
  BadRequestResponse | ForbiddenResponse
>;

export const useAdminUsersRoleAssignOrgownerPutV2 = <
  TError = ErrorType<BadRequestResponse | ForbiddenResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminUsersRoleAssignOrgownerPutV2>>,
    TError,
    { data: BodyType<AssignOrgOwnerRequest> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationResult<
  Awaited<ReturnType<typeof adminUsersRoleAssignOrgownerPutV2>>,
  TError,
  { data: BodyType<AssignOrgOwnerRequest> },
  TContext
> => {
  const mutationOptions =
    getAdminUsersRoleAssignOrgownerPutV2MutationOptions(options);

  return useMutation(mutationOptions);
};
